import PropTypes from 'prop-types';

export const peerChallengeShape = PropTypes.shape({
    programId: PropTypes.string,
    assetId: PropTypes.string,
    title: PropTypes.string,
    ProgramTile: PropTypes.shape({
        title: PropTypes.string,
        ctaText: PropTypes.string,
        ctaUrl: PropTypes.string,
    }),
    Topics: PropTypes.arrayOf(PropTypes.shape({
        title: PropTypes.string,
        anchorText: PropTypes.string,
        description: PropTypes.string,
        question: PropTypes.string,
        summaryOfResponses: PropTypes.string,
    })),
    Sources: PropTypes.arrayOf(PropTypes.shape({
        sourceType: PropTypes.string,
        sourceContent: PropTypes.string,
        sourceDate: PropTypes.string,
    })),
});

export default {
    peerChallengeShape,
};
